import * as React from 'react'
import MdButton from './MdButton'

class MdConfirm extends React.Component<MdConfirmProps, { canClick: boolean }> {

  constructor(props: any) {
    super(props)
    this.state = {
      canClick: true
    }
  }

  private async handleClick(callback) {
    // Prevents double clicks (and consequently hitting the api twice).
    if (this.state.canClick) {
      this.setState({
        canClick: false
      }, () => {
        callback()
      })
    }
  }

  public componentWillReceiveProps(newProps) {
    // Reset state when it is closed
    if (newProps.open === false) {
      this.setState({
        canClick: true
      })
    }
  }

  public render() {
    return (
      <div>
        {(this.props.open) ?
          (<div className='mdConfirm'>
            <div className='mdConfirm-content' style={this.props.style}>
              <div className='mdConfirm-header'>
                {this.props.header}
              </div>
              <div className='mdConfirm-body'>
                {this.props.children || (<p>{this.props.confirmText || 'Are you sure you wish to perform this action?'}</p>)}
              </div>
              <div className='mdConfirm-footer'>
                <MdButton
                  style={{
                    'boxShadow': 'inset 0 0 0 2px rgba(100, 100, 100, 0.6)',
                    'backgroundColor': 'transparent'
                  }}
                  text={(this.props.cancelText || 'Cancel')}
                  clickHandler={() => this.handleClick(this.props.cancelCallback)}
                />
                <MdButton
                  text={(this.props.confirmText || 'OK')}
                  clickHandler={() => this.handleClick(this.props.confirmCallback)}
                />
              </div>
            </div>
          </div>)
        : null }
      </div>
    )
  }
}

export default MdConfirm



// WEBPACK FOOTER //
// ./react/components/widgets/MdConfirm.tsx